import a from "./ghl-ui.es1145.js";
const s = (l) => {
  const { fontWeight: i, textColor1: r, textColor2: o, textColorDisabled: t, dividerColor: n, fontSize: e } = l;
  return {
    titleFontSize: e,
    titleFontWeight: i,
    dividerColor: n,
    titleTextColor: r,
    titleTextColorDisabled: t,
    fontSize: e,
    textColor: o,
    arrowColor: o,
    arrowColorDisabled: t,
    itemMargin: "16px 0 0 0",
    titlePadding: "16px 0 0 0"
  };
}, C = {
  name: "Collapse",
  common: a,
  self: s
}, c = C;
export {
  c as default,
  s as self
};
